import React, { Component } from 'react';
import './IconsWorldBase.css';
class IconWorldBase extends Component {
  render() {
    return (
      <svg style={{ display: 'none' }}>
        <defs>
          <symbol id="File_1" viewBox="0 0 17.76 24.14">
            <polyline points="13.26 0.5 13.26 4.49 17.26 4.49" />
            <path d="M17.26,22.84a.8.8,0,0,1-.79.8H1.29a.79.79,0,0,1-.79-.8V1.3A.8.8,0,0,1,1.29.5h12a.58.58,0,0,1,.45.23L17,4a.66.66,0,0,1,.23.5Z" />
            <line x1="13.88" y1="11.65" x2="3.86" y2="11.65" />
            <line x1="13.88" y1="14.85" x2="3.86" y2="14.85" />
            <line x1="13.88" y1="18.05" x2="3.86" y2="18.05" />
            <line x1="9.43" y1="8.45" x2="3.86" y2="8.45" />
          </symbol>
          <symbol id="File_2" viewBox="0 0 17.76 24.14">
            <polyline className="icon-world-base-2" points="13.26 0.5 13.26 4.49 17.26 4.49" />
            <path
              className="icon-world-base-2"
              d="M17.26,22.84a.8.8,0,0,1-.79.8H1.29a.79.79,0,0,1-.79-.8V1.3A.8.8,0,0,1,1.29.5h12a.58.58,0,0,1,.45.23L17,4a.66.66,0,0,1,.23.5Z"
            />
            <line className="icon-world-base-2" x1="13.88" y1="11.65" x2="3.86" y2="11.65" />
            <line className="icon-world-base-2" x1="13.88" y1="14.85" x2="3.86" y2="14.85" />
            <line className="icon-world-base-2" x1="13.88" y1="18.05" x2="3.86" y2="18.05" />
            <line className="icon-world-base-2" x1="9.43" y1="8.45" x2="3.86" y2="8.45" />
          </symbol>
          <symbol id="File_3" viewBox="0 0 17.76 24.14">
            <polyline className="icon-world-base-3" points="13.26 0.5 13.26 4.49 17.26 4.49" />
            <path
              className="icon-world-base-3"
              d="M17.26,22.84a.8.8,0,0,1-.79.8H1.29a.79.79,0,0,1-.79-.8V1.3A.8.8,0,0,1,1.29.5h12a.58.58,0,0,1,.45.23L17,4a.66.66,0,0,1,.23.5Z"
            />
            <line className="icon-world-base-3" x1="13.88" y1="11.65" x2="3.86" y2="11.65" />
            <line className="icon-world-base-3" x1="13.88" y1="14.85" x2="3.86" y2="14.85" />
            <line className="icon-world-base-3" x1="13.88" y1="18.05" x2="3.86" y2="18.05" />
            <line className="icon-world-base-3" x1="9.43" y1="8.45" x2="3.86" y2="8.45" />
          </symbol>
          <symbol id="Network_1" viewBox="0 0 24.13 23.71">
            <line x1="13.56" y1="11.91" x2="13.9" y2="18.82" />
            <line x1="4.47" y1="14.85" x2="11.26" y2="10.72" />
            <line x1="14.55" y1="7.63" x2="17.19" y2="3.68" />
            <line x1="19.92" y1="13.86" x2="15.25" y2="11.12" />
            <circle cx="21.72" cy="14.85" r="1.9" />
            <circle cx="13.35" cy="9.63" r="2.28" />
            <circle cx="13.35" cy="9.63" r="2.28" />
            <circle cx="18.04" cy="2.28" r="1.78" />
            <circle cx="18.04" cy="2.28" r="1.78" />
            <circle cx="13.86" cy="20.92" r="2.28" />
            <circle cx="13.86" cy="20.92" r="2.28" />
            <circle cx="2.78" cy="15.81" r="2.28" />
            <circle cx="2.78" cy="15.81" r="2.28" />
            <line x1="11.7" y1="7.86" x2="8.28" y2="4.94" />
            <circle cx="7.13" cy="4.05" r="1.77" />
            <circle cx="7.13" cy="4.05" r="1.77" />
          </symbol>
          <symbol id="Network_2" viewBox="0 0 24.13 23.71">
            <line className="icon-world-base-2" x1="13.56" y1="11.91" x2="13.9" y2="18.82" />
            <line className="icon-world-base-2" x1="4.47" y1="14.85" x2="11.26" y2="10.72" />
            <line className="icon-world-base-2" x1="14.55" y1="7.63" x2="17.19" y2="3.68" />
            <line className="icon-world-base-2" x1="19.92" y1="13.86" x2="15.25" y2="11.12" />
            <circle className="icon-world-base-2" cx="21.72" cy="14.85" r="1.9" />
            <circle className="icon-world-base-2" cx="13.35" cy="9.63" r="2.28" />
            <circle className="icon-world-base-2" cx="13.35" cy="9.63" r="2.28" />
            <circle className="icon-world-base-2" cx="18.04" cy="2.28" r="1.78" />
            <circle className="icon-world-base-2" cx="18.04" cy="2.28" r="1.78" />
            <circle className="icon-world-base-2" cx="13.86" cy="20.92" r="2.28" />
            <circle className="icon-world-base-2" cx="13.86" cy="20.92" r="2.28" />
            <circle className="icon-world-base-2" cx="2.78" cy="15.81" r="2.28" />
            <circle className="icon-world-base-2" cx="2.78" cy="15.81" r="2.28" />
            <line className="icon-world-base-2" x1="11.7" y1="7.86" x2="8.28" y2="4.94" />
            <circle className="icon-world-base-2" cx="7.13" cy="4.05" r="1.77" />
            <circle className="icon-world-base-2" cx="7.13" cy="4.05" r="1.77" />
          </symbol>
          <symbol id="Network_3" viewBox="0 0 24.13 23.71">
            <line className="icon-world-base-3" x1="13.56" y1="11.91" x2="13.9" y2="18.82" />
            <line className="icon-world-base-3" x1="4.47" y1="14.85" x2="11.26" y2="10.72" />
            <line className="icon-world-base-3" x1="14.55" y1="7.63" x2="17.19" y2="3.68" />
            <line className="icon-world-base-3" x1="19.92" y1="13.86" x2="15.25" y2="11.12" />
            <circle className="icon-world-base-3" cx="21.72" cy="14.85" r="1.9" />
            <circle className="icon-world-base-3" cx="13.35" cy="9.63" r="2.28" />
            <circle className="icon-world-base-3" cx="13.35" cy="9.63" r="2.28" />
            <circle className="icon-world-base-3" cx="18.04" cy="2.28" r="1.78" />
            <circle className="icon-world-base-3" cx="18.04" cy="2.28" r="1.78" />
            <circle className="icon-world-base-3" cx="13.86" cy="20.92" r="2.28" />
            <circle className="icon-world-base-3" cx="13.86" cy="20.92" r="2.28" />
            <circle className="icon-world-base-3" cx="2.78" cy="15.81" r="2.28" />
            <circle className="icon-world-base-3" cx="2.78" cy="15.81" r="2.28" />
            <line className="icon-world-base-3" x1="11.7" y1="7.86" x2="8.28" y2="4.94" />
            <circle className="icon-world-base-3" cx="7.13" cy="4.05" r="1.77" />
            <circle className="icon-world-base-3" cx="7.13" cy="4.05" r="1.77" />
          </symbol>
          <symbol id="User_1" viewBox="0 0 24 24">
            <path d="M23,19c-3.7-1.43-7.81-3.21-8.16-4.32V13.52a7.35,7.35,0,0,0,1.73-3.16,1.88,1.88,0,0,0,.36-2.73V5C16.91,2.34,15.42.5,12,.5S7.09,2.34,7.09,5v2.6a1.88,1.88,0,0,0,.36,2.73,7.34,7.34,0,0,0,1.73,3.17v1.16C8.84,15.78,4.73,17.56,1,19a.83.83,0,0,0-.52.77v2.9a.82.82,0,0,0,.81.83H22.69a.82.82,0,0,0,.81-.83v-2.9A.83.83,0,0,0,23,19Z" />
          </symbol>
          <symbol id="User_2" viewBox="0 0 24 24">
            <path
              className="icon-world-base-5"
              d="M23,19c-3.7-1.43-7.81-3.21-8.16-4.32V13.52a7.35,7.35,0,0,0,1.73-3.16,1.88,1.88,0,0,0,.36-2.73V5C16.91,2.34,15.42.5,12,.5S7.09,2.34,7.09,5v2.6a1.88,1.88,0,0,0,.36,2.73,7.34,7.34,0,0,0,1.73,3.17v1.16C8.84,15.78,4.73,17.56,1,19a.83.83,0,0,0-.52.77v2.9a.82.82,0,0,0,.81.83H22.69a.82.82,0,0,0,.81-.83v-2.9A.83.83,0,0,0,23,19Z"
            />
          </symbol>
          <symbol id="User_3" viewBox="0 0 24 24">
            <path
              className="icon-world-base-3"
              d="M23,19c-3.7-1.43-7.81-3.21-8.16-4.32V13.52a7.35,7.35,0,0,0,1.73-3.16,1.88,1.88,0,0,0,.36-2.73V5C16.91,2.34,15.42.5,12,.5S7.09,2.34,7.09,5v2.6a1.88,1.88,0,0,0,.36,2.73,7.34,7.34,0,0,0,1.73,3.17v1.16C8.84,15.78,4.73,17.56,1,19a.83.83,0,0,0-.52.77v2.9a.82.82,0,0,0,.81.83H22.69a.82.82,0,0,0,.81-.83v-2.9A.83.83,0,0,0,23,19Z"
            />
          </symbol>
          <symbol id="Host_1" viewBox="0 0 24.17 23.66">
            <path d="M8.37,19.78l-.48,3a.45.45,0,0,0,.48.4H15.8a.45.45,0,0,0,.48-.4l-.48-3" />
            <path d="M22,.5H2.13A1.63,1.63,0,0,0,.5,2.14V16a1.63,1.63,0,0,0,1.63,1.65H22A1.63,1.63,0,0,0,23.67,16V2.14A1.63,1.63,0,0,0,22,.5Z" />
            <line x1="0.5" y1="14.61" x2="23.67" y2="14.61" />
          </symbol>
          <symbol id="Host_2" viewBox="0 0 24.16 23.64">
            <path
              className="icon-world-base-2"
              d="M8.36,19.77l-.48,3a.45.45,0,0,0,.48.39H15.8a.45.45,0,0,0,.48-.39l-.48-3"
            />
            <path
              className="icon-world-base-2"
              d="M22,.5H2.13A1.63,1.63,0,0,0,.5,2.14V16a1.63,1.63,0,0,0,1.63,1.65H22A1.63,1.63,0,0,0,23.66,16V2.14A1.63,1.63,0,0,0,22,.5Z"
            />
            <line className="icon-world-base-2" x1="0.5" y1="14.6" x2="23.66" y2="14.6" />
          </symbol>
          <symbol id="Host_3" viewBox="0 0 24.16 23.64">
            <path
              className="icon-world-base-3"
              d="M8.36,19.77l-.48,3a.45.45,0,0,0,.48.39H15.8a.45.45,0,0,0,.48-.39l-.48-3"
            />
            <path
              className="icon-world-base-3"
              d="M22,.5H2.13A1.63,1.63,0,0,0,.5,2.14V16a1.63,1.63,0,0,0,1.63,1.65H22A1.63,1.63,0,0,0,23.66,16V2.14A1.63,1.63,0,0,0,22,.5Z"
            />
            <line className="icon-world-base-3" x1="0.5" y1="14.6" x2="23.66" y2="14.6" />
          </symbol>
          <symbol id="Host_2-blue" viewBox="0 0 24.16 23.64">
            <path
              className="icon-world-base-2 icon-world-base-2-blue"
              d="M8.36,19.77l-.48,3a.45.45,0,0,0,.48.39H15.8a.45.45,0,0,0,.48-.39l-.48-3"
            />
            <path
              className="icon-world-base-2 icon-world-base-2-blue"
              d="M22,.5H2.13A1.63,1.63,0,0,0,.5,2.14V16a1.63,1.63,0,0,0,1.63,1.65H22A1.63,1.63,0,0,0,23.66,16V2.14A1.63,1.63,0,0,0,22,.5Z"
            />
            <line className="icon-world-base-2 icon-world-base-2-blue" x1="0.5" y1="14.6" x2="23.66" y2="14.6" />
          </symbol>
          <symbol id="Host_2-yellow" viewBox="0 0 24.16 23.64">
            <path
              className="icon-world-base-2 icon-world-base-2-yellow"
              d="M8.36,19.77l-.48,3a.45.45,0,0,0,.48.39H15.8a.45.45,0,0,0,.48-.39l-.48-3"
            />
            <path
              className="icon-world-base-2 icon-world-base-2-yellow"
              d="M22,.5H2.13A1.63,1.63,0,0,0,.5,2.14V16a1.63,1.63,0,0,0,1.63,1.65H22A1.63,1.63,0,0,0,23.66,16V2.14A1.63,1.63,0,0,0,22,.5Z"
            />
            <line className="icon-world-base-2 icon-world-base-2-yellow" x1="0.5" y1="14.6" x2="23.66" y2="14.6" />
          </symbol>
          <symbol id="Host_2-orange" viewBox="0 0 24.16 23.64">
            <path
              className="icon-world-base-2 icon-world-base-2-orange"
              d="M8.36,19.77l-.48,3a.45.45,0,0,0,.48.39H15.8a.45.45,0,0,0,.48-.39l-.48-3"
            />
            <path
              className="icon-world-base-2 icon-world-base-2-orange"
              d="M22,.5H2.13A1.63,1.63,0,0,0,.5,2.14V16a1.63,1.63,0,0,0,1.63,1.65H22A1.63,1.63,0,0,0,23.66,16V2.14A1.63,1.63,0,0,0,22,.5Z"
            />
            <line className="icon-world-base-2 icon-world-base-2-orange" x1="0.5" y1="14.6" x2="23.66" y2="14.6" />
          </symbol>
          <symbol id="Host_2-red" viewBox="0 0 24.16 23.64">
            <path
              className="icon-world-base-2 icon-world-base-2-red"
              d="M8.36,19.77l-.48,3a.45.45,0,0,0,.48.39H15.8a.45.45,0,0,0,.48-.39l-.48-3"
            />
            <path
              className="icon-world-base-2 icon-world-base-2-red"
              d="M22,.5H2.13A1.63,1.63,0,0,0,.5,2.14V16a1.63,1.63,0,0,0,1.63,1.65H22A1.63,1.63,0,0,0,23.66,16V2.14A1.63,1.63,0,0,0,22,.5Z"
            />
            <line className="icon-world-base-2 icon-world-base-2-red" x1="0.5" y1="14.6" x2="23.66" y2="14.6" />
          </symbol>
          //
          <symbol id="_045__User-2" data-name="045_+User-2" viewBox="0 0 25.5 27.42">
            <path className="icon-world-base-7" d="M3.06,5.22H0V3H3.06V0H5.27V3H8.32v2.2H5.27v3H3.06Z" />
            <path
              className="icon-world-base-8"
              d="M24.54,23c-3.25-1.26-6.86-2.82-7.16-3.79v-1a6.45,6.45,0,0,0,1.52-2.78,1.65,1.65,0,0,0,.32-2.4V10.7c0-2.36-1.31-4-4.31-4s-4.31,1.61-4.31,4V13a1.65,1.65,0,0,0,.32,2.39,6.45,6.45,0,0,0,1.52,2.78v1c-.3,1-3.91,2.53-7.16,3.79a.73.73,0,0,0-.46.68v2.55a.72.72,0,0,0,.72.73H24.28a.72.72,0,0,0,.72-.73V23.64A.73.73,0,0,0,24.54,23Z"
            />
          </symbol>
          <symbol id="_042__Host-2" data-name="042_+Host-2" viewBox="0 0 25.5 25.21">
            <path
              className="icon-world-base-9"
              d="M13.31,22.13l-.37,2.28a.34.34,0,0,0,.37.3H19a.34.34,0,0,0,.37-.3L19,22.13"
            />
            <path
              className="icon-world-base-9"
              d="M23.75,7.41H8.55A1.24,1.24,0,0,0,7.31,8.67V19.23a1.25,1.25,0,0,0,1.25,1.26h15.2A1.25,1.25,0,0,0,25,19.23V8.67A1.24,1.24,0,0,0,23.75,7.41Z"
            />
            <line className="icon-world-base-9" x1="7.31" y1="18.18" x2="25" y2="18.18" />
            <path className="icon-world-base-9" d="M2.79,4.77H0v-2H2.79V0h2V2.76H7.61v2H4.82V7.48h-2Z" />
          </symbol>
          <symbol id="_044__File-2" data-name="044_+File-2" viewBox="0 0 25.5 30.5">
            <polyline className="icon-world-base-10" points="21.47 9.55 21.47 13.08 25 13.08" />
            <path
              className="icon-world-base-10"
              d="M25,29.29a.7.7,0,0,1-.7.7H10.89a.7.7,0,0,1-.69-.7v-19a.71.71,0,0,1,.69-.71H21.47a.51.51,0,0,1,.4.21l2.92,2.88a.58.58,0,0,1,.21.44Z"
            />
            <line className="icon-world-base-10" x1="22.02" y1="19.41" x2="13.17" y2="19.41" />
            <line className="icon-world-base-10" x1="22.02" y1="22.23" x2="13.17" y2="22.23" />
            <line className="icon-world-base-10" x1="22.02" y1="25.06" x2="13.17" y2="25.06" />
            <line className="icon-world-base-10" x1="18.08" y1="16.58" x2="13.17" y2="16.58" />
            <path className="icon-world-base-7" d="M3.21,5.48H0V3.17H3.21V0H5.53V3.17H8.74V5.48H5.53V8.59H3.21Z" />
          </symbol>
          <symbol id="_043__Network-2" data-name="043_+Network-2" viewBox="0 0 25.5 26.75">
            <line className="icon-world-base-11" x1="16.4" y1="16.6" x2="16.69" y2="22.51" />
            <line className="icon-world-base-11" x1="8.63" y1="19.11" x2="14.43" y2="15.58" />
            <line className="icon-world-base-11" x1="17.24" y1="12.94" x2="19.5" y2="9.56" />
            <line className="icon-world-base-11" x1="21.83" y1="18.27" x2="17.84" y2="15.92" />
            <circle className="icon-world-base-11" cx="23.37" cy="19.11" r="1.63" />
            <circle className="icon-world-base-11" cx="16.22" cy="14.65" r="1.95" />
            <circle className="icon-world-base-11" cx="16.22" cy="14.65" r="1.95" />
            <circle className="icon-world-base-11" cx="20.23" cy="8.37" r="1.52" />
            <circle className="icon-world-base-11" cx="20.23" cy="8.37" r="1.52" />
            <circle className="icon-world-base-11" cx="16.65" cy="24.3" r="1.95" />
            <circle className="icon-world-base-11" cx="16.65" cy="24.3" r="1.95" />
            <circle className="icon-world-base-11" cx="7.19" cy="19.94" r="1.95" />
            <circle className="icon-world-base-11" cx="7.19" cy="19.94" r="1.95" />
            <line className="icon-world-base-11" x1="14.81" y1="13.14" x2="11.88" y2="10.64" />
            <circle className="icon-world-base-11" cx="10.91" cy="9.88" r="1.52" />
            <circle className="icon-world-base-11" cx="10.91" cy="9.88" r="1.52" />
            <path className="icon-world-base-7" d="M3.1,5.38H0V3.11H3.1V0H5.35V3.11h3.1V5.38H5.35V8.45H3.1Z" />
          </symbol>
          /*remote/local ip */
          <symbol id="L_09_local_ip-2" data-name="L_09_local ip-2" viewBox="0 0 24.75 17.61">
            <circle className="icon-world-base-12" cx="12.38" cy="8.81" r="1.5" />
            <path className="icon-world-base-13" d="M4,.38A11.52,11.52,0,0,0,4,17.24" />
            <path className="icon-world-base-13" d="M7.54,13.15a5.76,5.76,0,0,1,0-8.69" />
            <path className="icon-world-base-13" d="M20.71,17.24a11.52,11.52,0,0,0,0-16.86" />
            <path className="icon-world-base-13" d="M17.21,4.46a5.76,5.76,0,0,1,0,8.69" />
          </symbol>
          <symbol id="L_10_remote_ip-2" data-name="L_10_remote ip-2" viewBox="0 0 24.75 19.81">
            <circle className="icon-world-base-12" cx="12.38" cy="18.31" r="1.5" />
            <path className="icon-world-base-13" d="M20.46,9.35a11.12,11.12,0,0,0-16.16,0" />
            <path className="icon-world-base-13" d="M24.38,5.47a16.69,16.69,0,0,0-24,0" />
            <path className="icon-world-base-13" d="M8.21,13.23a5.56,5.56,0,0,1,8.33,0" />
          </symbol>
          <symbol id="multiple_external_comm_2" data-name="multiple external comm 2" viewBox="0 0 35.46 24.33">
            <g id="external_comm_2" data-name="external comm 2">
              <g id="L_10_remote_ip-2" data-name="L_10_remote ip-2">
                <circle className="icon-world-base-12" cx="23.08" cy="22.83" r="1.5" />
                <path className="icon-world-base-14" d="M31.17,13.87a11.12,11.12,0,0,0-16.16,0" />
                <path className="icon-world-base-14" d="M35.08,10a16.69,16.69,0,0,0-24,0" />
                <path className="icon-world-base-14" d="M18.92,17.75a5.56,5.56,0,0,1,8.33,0" />
              </g>
            </g>
            <path className="icon-world-base-7" d="M3.06,5.22H0V3H3.06V0H5.27V3H8.32v2.2H5.27v3H3.06Z" />
          </symbol>
          <symbol id="multiple_internal_comm_2" data-name="multiple internal comm 2" viewBox="0 0 35.46 24.52">
            <g id="internal_comm_2" data-name="internal comm 2">
              <g id="L_09_local_ip-2" data-name="L_09_local ip-2">
                <circle className="icon-world-base-12" cx="23.08" cy="15.72" r="1.5" />
                <path className="icon-world-base-14" d="M14.75,7.29a11.52,11.52,0,0,0,0,16.86" />
                <path className="icon-world-base-14" d="M18.25,20.06a5.76,5.76,0,0,1,0-8.69" />
                <path className="icon-world-base-14" d="M31.41,24.15a11.52,11.52,0,0,0,0-16.86" />
                <path className="icon-world-base-14" d="M27.92,11.37a5.76,5.76,0,0,1,0,8.69" />
              </g>
            </g>
            <path className="icon-world-base-7" d="M3.06,5.22H0V3H3.06V0H5.27V3H8.32v2.2H5.27v3H3.06Z" />
          </symbol>
          <symbol id="_2734-2" data-name="2734-2" viewBox="0 0 22.64 27.3">
            <polyline points="13.5 0.5 13.5 4.5 17.5 4.5" />
            <path d="M12.86,23.5H1.29a.8.8,0,0,1-.79-.8V1.31A.8.8,0,0,1,1.29.5H13.5A.58.58,0,0,1,14,.73L17.26,4a.65.65,0,0,1,.24.5v13" />
            <line x1="7.58" y1="8.52" x2="14.45" y2="8.52" />
            <rect x="3.51" y="7.46" width="1.93" height="2.05" />
            <line x1="7.58" y1="12.52" x2="14.45" y2="12.52" />
            <rect x="3.51" y="11.46" width="1.93" height="2.05" />
            <line x1="7.58" y1="16.52" x2="14.45" y2="16.52" />
            <rect x="3.51" y="15.46" width="1.93" height="2.05" />
            <circle cx="17.5" cy="22.16" r="4.64" />
            <line x1="16.7" y1="24.09" x2="20.05" y2="20.51" />
            <line x1="16.7" y1="24.09" x2="15.14" y2="22.43" />
          </symbol>
        </defs>
      </svg>
    );
  }
}

export default IconWorldBase;

/*
<g id="Layer_2" data-name="Layer 2">
        <g id="Layer_8" data-name="Layer 8">
            <g id="md_network">
                <use width="17.76" height="24.14" transform="translate(75.28 65.58)" xlink:href="#File_2" />
                <use width="17.76" height="24.14" transform="translate(7.17 65.58)" xlink:href="#File_3" />
                <use width="24.12" height="23.71" transform="translate(71.01)" xlink:href="#Network_2" />
                <use width="24.12" height="23.71" transform="translate(1.66)" xlink:href="#Network_3" />
                <use width="17.76" height="24.14" transform="translate(148.72 65.58)" xlink:href="#File_1" />
                <use width="24.12" height="23.71" transform="translate(145.25 0.84)" xlink:href="#Network_1" />
                <use width="24" height="24" transform="translate(146.03 130.53)" xlink:href="#User_1" />
                <use width="24" height="24" transform="translate(75.34 130.53)" xlink:href="#User_2" />
                <use width="24" height="24" transform="translate(4.64 130.53)" xlink:href="#User_3" />
                <text className="icon-world-base-6" transform="translate(229.08 13.33)">24px_Network</text>
                <text className="icon-world-base-6" transform="translate(229.08 75.66)">24px_File</text>
                <text className="icon-world-base-6" transform="translate(229.08 147.76)">24px_User</text>
            </g>
            <use width="24.16" height="23.64" transform="translate(0 192.95)" xlink:href="#Host_3" />
            <use width="24.16" height="23.64" transform="translate(67.95 192.95)" xlink:href="#Host_2" />
            <use width="24.17" height="23.66" transform="translate(147.78 193.22)" xlink:href="#Host_1" />
            <text className="icon-world-base-6" transform="translate(229.08 205.61)">24px_Host</text>
        </g>
    </g>
    */
